import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getUserMapActivities = createAsyncThunk(
    'userMapActivities/getMapActivities',
    async ({ filtersObject, lang }) => {
        console.log('map filtersObject: ', filtersObject)
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/user-activities?lang=${lang}`;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        };
        const options = {
            method: 'POST',
            headers,
            body: JSON.stringify({ filtersObject, isMap: true })
        };
        const response = await fetch(url, options);
        if (response.ok) {
            const result = await response.json();
            return result
        } else {
            const error = await response.json();
            throw error
        };
    }
)

const userMapActivities = createSlice({
    name: 'userMapActivities',
    initialState: {
        isLoading: false,
        error: null,
        data: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserMapActivities.pending, (state) => {
                state.error = null;
                state.isLoading = true;
            })
            .addCase(getUserMapActivities.fulfilled, (state, action) => {
                state.data = action.payload.payload;
                state.activitiesAmount = action.payload.activitiesAmount;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getUserMapActivities.rejected, (state, action) => {
                if (action.error.message === "Nessuna attività trovata") state.data = []
                state.error = action.error;
                state.isLoading = false;
            })
    }
})

export default userMapActivities.reducer;